import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

const allowedTracingDomains = ['.lemonade.com', '.lmndstaging.com'];

export const initializeDatadogRum = () => {
  try {
    datadogRum.init({
      applicationId: 'a1a4ee75-48ab-4551-be86-0f26d4272e33',
      clientToken: 'pubc7d752bfe62eb2c3593d3eed3c0b8d92',
      site: 'datadoghq.com',
      service: 'marketing-edge',
      env: process.env.NEXT_PUBLIC_ENV_ID ?? 'development',
      version: '1.0.0',
      sessionSampleRate: 8,
      sessionReplaySampleRate: 0,
      defaultPrivacyLevel: 'mask-user-input',
      plugins: [reactPlugin({ router: false })],
      allowedTracingUrls: [
        url => {
          try {
            const parsedURL = new URL(url);
            return allowedTracingDomains.some(domain => parsedURL.hostname.endsWith(domain));
          } catch (_) {
            return false;
          }
        },
      ],
    });
  } catch (error) {
    console.error('Error initializing Datadog RUM', error);
  }
};

export const trackWithDatadogRum = (event: string, params: Record<string, unknown>) => {
  try {
    datadogRum.addAction(event, params);
  } catch (_) {
    // Silent fail or log locally
    console.warn('Error tracking event with Datadog RUM');
  }
};
